import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { rgba } from "polished";

import { BREAKPOINTS, COLORS } from "@onelogin/react-components";

const Background = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: ${COLORS.GRAY_COLORS.GRAY_98};

  @media only screen and (min-width: ${BREAKPOINTS.PORTAL_MIDDLE}) {
    ${props => props.imageUrl && css`
      background: url(${props.imageUrl}) no-repeat center center fixed;
      background-size: cover;
    `};
  }
`;

const Overlay = styled.div`
  display: block;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  ${props => props.backgroundColor && css`
    background-color: ${props.backgroundColor}
  `};

  @media only screen and (max-width: ${BREAKPOINTS.PORTAL_MIDDLE}),
  only screen and (max-height: ${BREAKPOINTS.PHONE_LARGE}) {
    background-color: #ffffff;
  }
`;

const BackgroundContent = ({ imageUrl, overlayColor, overlayOpacity }) => {
  const backgroundColor = rgba(overlayColor, parseFloat(overlayOpacity) / 100);
  return (
    <>
      <Background imageUrl={imageUrl} />
      <Overlay backgroundColor={backgroundColor} />
    </>
  );
};

BackgroundContent.propTypes = {
  imageUrl: PropTypes.string,
  overlayColor: PropTypes.string,
  overlayOpacity: PropTypes.string
};

export default BackgroundContent;
